import { StackView } from '@planningcenter/tapestry-react';
import React from 'react';

const SwitchView = ({ activeIndex, children }) => {
    const childCount = React.Children.count(children);
    const validatedIndex = activeIndex < 0
        ? 0
        : activeIndex > childCount - 1
            ? childCount - 1
            : activeIndex;
    return (React.createElement(StackView, { grow: 1, overflow: "hidden", position: "relative" }, React.Children.map(children, (view, index) => {
        const inView = index === validatedIndex;
        return (React.createElement(StackView, { "aria-hidden": !inView, visibility: inView ? "visible" : "hidden", height: "100%", key: index, opacity: inView ? 1 : 0, pointerEvents: inView ? "auto" : "none", position: "absolute", top: 0, width: "100%", transform: inView
                ? "translateX(0)"
                : index < activeIndex
                    ? "translateX(-100px)"
                    : "translateX(100px)", transition: "visibility 100ms 50ms ease-in-out, transform 200ms ease-in-out, opacity 100ms 50ms ease-in-out" }, view));
    })));
};

export { SwitchView };
//# sourceMappingURL=switch_view.js.map
